/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Col, Divider, Empty, Form, Input, List, Row, Select, Tooltip, Upload } from 'antd';

import { DeleteOutlined, EditOutlined, QuestionOutlined, UploadOutlined } from '@ant-design/icons';

function CertificateSettings({
  loading,
  fileList,
  submitFileList,
  editingIndex,
  editValue,
  setEditValue,
  setScreenModified,
  handleCertificateModelUploadChange,
  handleCertificateModelStartEdit,
  handleCertificateModelCancelEdit,
  handleCertificateModelEdit,
  handleCertificateModel,
  handleCertificateModelDelete,
  handleImport,
  setIsCertificateModalVisible,
  formUploadFile,
  fieldsPermissions,
}) {
  const hasCertificatePermissions = fieldsPermissions?.CertificateModel.access !== 0;

  if (!hasCertificatePermissions)
    return (
      <div style={{ height: 100, width: '100%' }}>
        <Empty description="Nenhuma configuração de modelo de certificado disponível" />
      </div>
    );

  const handleAdd = async () => {
    await formUploadFile.validateFields();
    handleCertificateModel();
  };

  const renderCertificateModelList = (item, index) => {
    let modelTypeName = '';

    switch (item.modelType) {
      case 1:
        modelTypeName = 'Certificado Aluno';
        break;
      case 2:
        modelTypeName = 'Certificado Empresa';
        break;
      case 3:
        modelTypeName = 'Certificado Empresa NR 23';
        break;
      case 4:
        modelTypeName = 'Atestado NR 23';
        break;
      case 5:
        modelTypeName = 'Atestado NR 23 MC Donalds';
        break;
      case 6:
        modelTypeName = 'Carteirinha';
        break;
      default:
        break;
    }

    return (
      <List.Item
        key={item.name}
        style={{ padding: 12, display: 'flex', justifyContent: 'space-between' }}
      >
        {editingIndex === index ? (
          <Input
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onPressEnter={() => handleCertificateModelEdit(index)}
            onBlur={() => handleCertificateModelCancelEdit()}
          />
        ) : (
          <>
            {item.label} | {modelTypeName}
            <div>
              <EditOutlined
                type="link"
                onClick={() => handleCertificateModelStartEdit(index, item.label)}
                style={{ marginRight: 8 }}
              />
              <DeleteOutlined
                type="link"
                onClick={() => handleCertificateModelDelete(item, index)}
                style={{ color: 'red' }}
              />
            </div>
          </>
        )}
      </List.Item>
    );
  };

  return (
    <Form
      form={formUploadFile}
      disabled={loading}
      name="settingsFormCertificate"
      layout="vertical"
      autoComplete="off"
      onChange={() => setScreenModified(true)}
      style={{ marginBottom: 32 }}
    >
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <Divider
            className="configuration-divider"
            orientation="left"
            style={{ marginBottom: 0, marginLeft: 0 }}
          >
            Modelos de Certificado
            <Tooltip title="Mapeamento de Campos">
              <Button
                type="primary"
                icon={<QuestionOutlined />}
                onClick={() => setIsCertificateModalVisible(true)}
                style={{ marginLeft: 8 }}
              />
            </Tooltip>
          </Divider>
        </Col>

        <Col span={12}>
          <Row gutter={[24, 0]}>
            <Col span={24}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório!',
                  },
                ]}
                style={{ marginTop: 12 }}
              >
                <Upload
                  beforeUpload={() => false}
                  onChange={handleCertificateModelUploadChange}
                  customRequest={({ file }) => handleImport(file)}
                  disabled={loading}
                  fileList={fileList}
                >
                  <Button icon={<UploadOutlined />}>Selecionar arquivo</Button>
                </Upload>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Nome"
                name="certificateModelFileName"
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Tipo de Modelo"
                name="certificateModelType"
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Select
                  options={[
                    { label: 'Certificado Aluno', value: 1 },
                    { label: 'Certificado Empresa', value: 2 },
                    { label: 'Certificado Empresa NR 23', value: 3 },
                    { label: 'Atestado NR 23', value: 4 },
                    { label: 'Atestado NR 23 MC Donalds', value: 5 },
                    { label: 'Carteirinha', value: 6 },
                  ]}
                  allowClear
                  placeholder="Selecione"
                  optionFilterProp="label"
                  dropdownStyle={{ borderRadius: 16 }}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Button type="primary" block htmlType="button" onClick={handleAdd}>
                Adicionar
              </Button>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <List
            bordered
            style={{ borderRadius: 28 }}
            dataSource={submitFileList}
            renderItem={renderCertificateModelList}
          />
        </Col>
      </Row>
    </Form>
  );
}

export default CertificateSettings;
